import request from '@/utils/request';

//////////////////////대시보드 START /////////////////////////
//유저정보 조회
export function userDashboard(data) {
	return request({
		url: '/v2/mybiz/userDashboard',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}
//유저정보 저장
export function saveMybizDashBoard(data) {
	return request({
		url: '/user/saveMybizDashBoard',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}

//최근 구매내역 2건 조회
export function searchNewOrderList(data) {
	return request({
		url: '/mybiz/searchNewOrderList',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}
//////////////////////대시보드 END  /////////////////////////

//////////////////// 발송번호관리 START ////////////////////

// 발송번호관리 - 휴대폰 인증 문자 발송 요청
export function getSendUserCallbackSmsVerification(data) {
	return request({
		url: '/authMobile/sendUserCallbackSmsVerification',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}
// 발송번호관리 - 휴대폰 인증 문자 확인
export function getSendUserCallbackSmsConfirm(data) {
	return request({
		url: '/authMobile/sendUserCallbackSmsConfirm',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}
// 발송번호관리 - [휴대번호] 등록
export function getAddMobileNo(data) {
	return request({
		url: '/msgsvc/userCallback/addMobileNo',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}
// 발송번호관리 - [유선전화] 등록
export function getAddTelNo(data) {
	return request({
		url: '/msgsvc/userCallback/addTelNo',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}
// 발송번호관리 - 조회
export function getTelUserList(data) {
	return request({
		url: '/userCallback/list',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}
// 발송번호관리 - 변경
export function getTelSave(data) {
	return request({
		url: '/userCallback/save',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}
// 발송번호관리 - 제거
export function getTelDelete(data) {
	return request({
		url: '/userCallback/remove',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}
//////////////////// 발송번호관리 END ////////////////////

//////////////////// 문자메시지 START ////////////////////

// 문자메시지 - 카테고리 목록 조회
export function getMmsCategoryList(data) {
	return request({
		url: '/mmsCategory/list',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}
// 문자메시지 - 상용구 목록 조회
export function getMmsTxtMgmtList(data) {
	return request({
		url: '/mmsTxtMgmt/list',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}
// 문자메시지 - 사용자 문자메세지 목록 조회
export function getMmsUserTxtMgmtList(data) {
	return request({
		url: '/mmsUserTxtMgmt/list',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}
// 문자메시지 - 사용자 문자메세지 등록
export function getMmsUserTxtMgmtAdd(data) {
	return request({
		url: '/mmsUserTxtMgmt/add',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}
// 문자메시지 - 사용자 문자메세지 수정
export function getMmsUserTxtMgmtModify(data) {
	return request({
		url: '/mmsUserTxtMgmt/save',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}
// 문자메시지 - 사용자 문자메세지 삭제
export function getMmsUserTxtMgmtRemove(data) {
	return request({
		url: '/mmsUserTxtMgmt/remove',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}

// 문자메시지 - 꾸미기 배너 등록
export function getMmsBannerAdd(data) {
	return request({
		url: '/mmsBanner/add',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}

// 문자메시지 - 꾸미기 배너 리스트
export function getMmsBannerList(data) {
	return request({
		url: '/mmsBanner/list',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}

// 문자메시지 - 꾸미기 마이 배너 리스트
export function getMmsBannerMyList(data) {
	return request({
		url: '/mmsBanner/myList',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}

// 문자메시지 - 꾸미기 배너 기본값 정보 조회
export function getMmsBannerDefaultY(data) {
	return request({
		url: '/mmsBanner/defaultY',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}

// 문자메시지 - 꾸미기 배너 기본값 설정
export function getMmsBannerSaveDefaultYes(data) {
	return request({
		url: '/mmsBanner/saveDefaultYes',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}

// 문자메시지 - 꾸미기 배너 정보삭제
export function getMmsBannerRemove(data) {
	return request({
		url: '/mmsBanner/remove',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}

// 문자메시지 - 꾸미기 카드 등록
export function getMmsCardAdd(data) {
	return request({
		url: '/mmsCard/add',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}

// 문자메시지 - 꾸미기 카드 리스트
export function getMmsCardList(data) {
	return request({
		url: '/mmsCard/list',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}

// 문자메시지 - 꾸미기 마이 카드 리스트
export function getMmsCardMyList(data) {
	return request({
		url: '/mmsCard/myList',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}

// 문자메시지 - 꾸미기 카드 기본값 정보 조회
export function getMmsCardDefaultY(data) {
	return request({
		url: '/mmsCard/defaultY',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}

// 문자메시지 - 꾸미기 카드 기본값 설정
export function getMmsCardSaveDefaultYes(data) {
	return request({
		url: '/mmsCard/saveDefaultYes',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}

// 문자메시지 - 꾸미기 카드 정보삭제
export function getMmsCardRemove(data) {
	return request({
		url: '/mmsCard/remove',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}

//////////////////// 문자메시지 END ////////////////////

//////////////////// 회원정보관리 START ////////////////////
// 회원정보관리 - 회원 정보 수정
export function getUserSave(data) {
	return request({
		url: '/user/save',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}
// 회원정보관리 - 회원 정보 상세
export function getUserDetail(data) {
	return request({
		url: '/user/detail',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}
// 회원정보관리 - 비밀번호 체크 회원 정보 상세
export function getUserManage(data) {
	return request({
		url: '/user/manage',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}
// 회원정보관리 - 비밀번호 확인
export function getUserPwCheck(data) {
	return request({
		url: '/v2/user/pwCheck',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}
// 회원정보관리 - 탈퇴처리
export function getUserSaveWithdraw(data) {
	return request({
		url: '/user/saveWithdraw',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}
// 회원정보관리 - 탈퇴 정보 전 조회
export function getUserWithdrawInfo(data) {
	return request({
		url: '/user/withdrawInfo',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}
// 회원정보관리 - 사용자 결제취소 및 예약발송 건수
export function detailServiceApiSendCnt(data) {
	return request({
		url: '/serviceApi/detailServiceApiSendCnt',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}
//////////////////// 회원정보관리 END ////////////////////

//////////////////// 서브회원관리 START ///////////////////////
// 서브회원관리 - 회원등록
export function getSubMemberAdd(data) {
	return request({
		url: '/subUser/add',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}
// 서브회원관리 - 회원목록
export function getSubMemberList(data) {
	return request({
		url: '/v2/subUser/list',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}

// 서브회원관리 - 회원상세
export function getSubMemberDetail(data) {
	return request({
		url: '/subUser/detail',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}
// 서브회원관리 - 사용자 상태 갯수 조회
export function getUserStatusCount(data) {
	return request({
		url: '/subUser/getUserStatusCount',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}
// 서브회원관리 - 사용자 상태 변경
export function saveUserStatus(data) {
	return request({
		url: '/subUser/saveUserStatus',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}
// 서브회원관리 - 비즈머니 부여/회수
export function bizPoint(data) {
	return request({
		url: '/subUser/bizPoint',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}
// 서브회원관리 - 서브 사용자 구매목록 조회
export function orderHistoryList(data) {
	return request({
		url: '/subUser/orderHistoryList',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}

// 서브회원관리 - 서브 구매관리 리스트
export function searchOrderPurMgmtListSub(data) {
	return request({
		url: '/mybiz/searchOrderPurMgmtListSub',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}

// 서브회원관리 - 서브 사용자 비밀번호 발송
export function sendPassword(data) {
	return request({
		url: '/subUser/sendPassword',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}

// 서브회원관리 - 비즈머니 충전/차감
export function setBizPoint(data) {
	return request({
		url: '/subUser/setBizPoint',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}

// 서브회원관리 - 서브 사용자 탈퇴 처리
export function saveWithdraw(data) {
	return request({
		url: '/subUser/saveWithdraw',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}

// 서브회원관리 - 회원 등록 전 유효성 체크
export function addValid(data) {
	return request({
		url: '/subUser/addValid',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}
//서브회원 비즈포인트 총합 조회
export function searchBizSubPoint(data) {
	return request({
		url: '/bizPoint/searchBizSubPoint',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}

// 회원정보관리 - 탈퇴처리
export function subUserSaveWithdraw(data) {
	return request({
		url: '/subUser/saveWithdraw',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}
//////////////////// 서브회원관리 END ///////////////////////

/////////////////////////// 비즈머니 START ///////////////////////////
// 비즈머니 관리 - 비즈포인트 조회
export function searchBizPoint(data) {
	return request({
		url: '/bizPoint/searchBizPoint',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}

// 비즈머니 관리 - 비즈머니 관리 조회(리스트)
export function searchBizMoneyList(data) {
	return request({
		url: '/bizPoint/searchBizMoneyList',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}
// 비즈머니 관리 - 비즈머니 취소
export function setBizPointAddCancel(data) {
	return request({
		url: '/bizPoint/setBizPointAddCancel',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}
// 비즈머니 관리 - 당일 충전금액 조회
export function searchBizPointTodayChg(data) {
	return request({
		url: '/bizPoint/searchBizPointTodayChg',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}
// 비즈머니 관리 - 비즈머니 충전
export function setBizPointAdd(data) {
	return request({
		url: '/bizPoint/setBizPointAdd',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}
// 비즈머니 관리 - 환불신청
export function addBizmoneyRefund(data) {
	return request({
		url: '/bizPoint/addBizmoneyRefund',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}
// 비즈머니 관리 - 가상계좌 충전 취소 요청
export function addBizmoneyChgCancelVC(data) {
	return request({
		url: '/bizPoint/addBizmoneyChgCancelVC',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}
// 비즈머니 관리 - 충전 입금대기 취소
/*
export function saveBizMoneyCancelDeposit (data) {
  return request({
    url: '/bizPoint/saveBizMoneyCancelDeposit',
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    data
  })
}
*/

// 비즈머니 관리 - 충전 입금대기 취소 version2
export function saveBizMoneyCancelDeposit(data) {
	return request({
		url: '/pg/cancelPay',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}
// 비즈머니 관리 - 거래명세서 조회
export function popBizMoneyDeal(data) {
	return request({
		url: '/bizPoint/popBizMoneyDeal',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}

// 비즈머니 관리 - 기간별거래명세서 조회
export function popOrderPurTotal(data) {
	return request({
		url: '/mybiz/popOrderPurTotal',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}

export function saveBizAddr(data) {
	return request({
		url: '/user/saveBizAddr',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}
/////////////////////////// 비즈머니 END ///////////////////////////

/////////////////////////// 구매관리 START ///////////////////////////
//구매관리 - 구매관리 리스트
export function searchOrderPurMgmtList(data) {
	return request({
		url: '/v2/mybiz/searchOrderPurMgmtList',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}

//구매관리 - 구매관리 리스트 상세
export function searchOrderPurMgmtListDtl(data) {
	return request({
		url: '/v2/mybiz/searchOrderPurMgmtListDtl',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}

//구매관리 - 구매관리 리스트 상세
export function searchSurveyOrderPurMgmtListDtl(data) {
	return request({
		url: '/v2/survey/prchmng/searchOrderPurMgmtListDtl',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}

//구매관리 - 구매관리 리스트 상세 결제정보
export function searchOrderPurMgmtListPayAmount(data) {
	return request({
		url: '/mybiz/searchOrderPurMgmtListPayAmount',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}

//구매관리 - 구매관리 리스트 MMS 발송 리스트 조회
export function searchOrderPurMgmtSendMmsList(data) {
	return request({
		url: '/v2/mybiz/searchOrderPurMgmtSendMmsList',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}

//구매관리 - 구매관리 MMS재발송(번호변경 포함)
export function saveMmsReSend(data) {
	return request({
		url: '/mybiz/saveMmsReSend',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}

//구매관리 - 구매관리 수신자 정보 파기 요청
export function saveReceiverInfoDestroy(data) {
	return request({
		url: '/mybiz/saveReceiverInfoDestroy',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}

//구매관리 - 구매관리 리스트 수신자 보기 버튼
export function searchMmsReceiverInfo(data) {
	return request({
		url: '/mybiz/searchMmsReceiverInfo',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}

//구매관리 - 쿠폰별 취소 대상자 조회
export function searchMmsListCpnCan(data) {
	return request({
		url: '/v2/mybiz/searchMmsListCpnCan',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}

//구매관리 - 예약 및 수신자별 쿠폰 조회 팝업
export function searchMmsListBookingCpnCan(data) {
	return request({
		url: '/v2/mybiz/searchMmsListBookingCpnCan',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}

//구매관리 - 쿠폰별 취소 요청
export function saveCpnCan(data) {
	return request({
		url: '/mybiz/saveCpnCan',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}

//구매관리 - 쿠폰 취소(발송전 취소)
export function saveBookingCpnCan(data) {
	return request({
		url: '/mybiz/saveBookingCpnCan',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}

//구매관리 - 번호변경 대상자 조회
export function searchMmsListChgPhoneNo(data) {
	return request({
		url: '/mybiz/searchMmsListChgPhoneNo',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}

//구매관리 - 메세지 미리 보기
export function searchMmsPreview(data) {
	return request({
		url: '/mybiz/searchMmsPreview',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}

//구매관리 - 주문번호 기준 발신번호 조회
export function searchOrderCallbackNoList(data) {
	return request({
		url: '/mybiz/searchOrderCallbackNoList',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}

//구매관리 - 거래명세서
export function popOrderPurMgmtDealDtl(data) {
	return request({
		url: '/mybiz/popOrderPurMgmtDealDtl',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}

//구매관리 - 전체 취소
export function saveAllOrderCancel(data) {
	return request({
		url: '/mybiz/saveAllOrderCancel',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}

//구매관리 - 설문 취소
export function cancelSurvey(data) {
	return request({
		url: '/v2/survey/prchmng/saveCancel',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}
/////////////////////////// 구매관리 END ///////////////////////////

export function searchUserPwd(data) {
	return request({
		url: '/searchUserPwd',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}

/////////////////////////// 알림톡 /////////////////////////////////
export function getTmpltCondList(data) {
	return request({
		url: '/talkTmpltMgmt/tmpltCondList',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}

export function getSndProfList(data) {
	return request({
		url: '/talkTmpltMgmt/sndProfList',
		method: 'post',
		headers: { 'content-type': 'application/json' },
		data,
	});
}

export function regSndTmplt(data) {
	return request({
		url: '/talkTmpltMgmt/regSndTmplt',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}

export function getTemplateList(data) {
	return request({
		url: '/talkTmpltMgmt/templateList',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}

export function getTemplate(data) {
	return request({
		url: '/talkTmpltMgmt/template',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}

export function getReqTemplateQna(data) {
	return request({
		url: '/talkTmpltMgmt/templateQnaList',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}

export function regTemplateQna(data) {
	return request({
		url: '/talkTmpltMgmt/reqTemplateQna',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}

export function updateTemplate(data) {
	return request({
		url: '/talkTmpltMgmt/updateTemplate',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}

export function requestTemplate(data) {
	return request({
		url: '/talkTmpltMgmt/requestTemplate',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}

export function cancelReqeustTemplate(data) {
	return request({
		url: '/talkTmpltMgmt/cancelReqeustTemplate',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}

export function deleteTemplate(data) {
	return request({
		url: '/talkTmpltMgmt/deleteTemplate',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}

export function getTemplateCategoryList(data) {
	return request({
		url: '/talkTmpltMgmt/templateCategoryList',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}

export function checkName(data) {
	return request({
		url: '/talkTmpltMgmt/checkName',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}

// 인증 IP 등록
export function addAuthIp(data) {
	return request({
		url: '/v2/mybiz/addClientIp',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}

// 인증 IP 검색(페이지 로딩)
export function getAuthIpList(data) {
	return request({
		url: '/v2/mybiz/getAuthIpList',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}

// 인증 IP 검색(페이지 검색)
export function getSearchAuthIpList(data) {
	return request({
		url: '/v2/mybiz/getSearchAuthIpList',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}

// 인증 IP 등록 해제
export function updateAuthIpList(data) {
	return request({
		url: '/v2/mybiz/updateAuthIpList',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}

// 인증 IP 등록(로그인 페이지)
export function chkAddAuthIp(data) {
	return request({
		url: '/v2/mybiz/chkAddClientIp',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}

// 인증번호 발송
export function sendLoginSmsVerification(data) {
	return request({
		url: '/authMobile/sendLoginSmsVerification',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}

// 인증번호 체크
export function sendLoginSmsConfirm(data) {
	return request({
		url: '/authMobile/sendLoginSmsConfirm',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}

// 인증 IP 등록 중복 체크
export function duplicateChk(data) {
	return request({
		url: '/v2/mybiz/getCheckClientIp',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}

// 구매관리 - 구매항목 브랜드코드 조회
export function searchOrderPurBrandNoList(data) {
	return request({
		url: '/mybiz/searchOrderPurBrandNoList',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}

// 구매관리 - 구매항목 브랜드코드 조회
export function getPinManageCouponStatus(data) {
	return request({
		url: '/pin/manage/coupon-status',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}
